// STEPS
export const MAIN_DATA_STEP: string = 'data';
export const RECIPIENTS_STEP: string = 'recipients';
export const DOCS_TO_TRANSFER_STEP: string = 'docsToTransfer';
export const FILES_STEP: string = 'files';

// MAIN_DATA_STEP PROGRAMMING
export const STRUCTURE_FIELD: string = 'structure';
export const MONTH_FIELD: string = 'month';
export const FORTNIGHT_FIELD: string = 'fortnight';
export const COURSE_FIELD: string = 'course';
export const ACTIVE_FIELD: string = 'active';
export const DATE_FIELD: string = 'date';
export const EU_DATE_FIELD: string = 'dateEU';

// MAIN_DATA_STEP
export const SUPPORT_FIELD: string = 'support';
//export const COURSE_FIELD: string = 'course';
export const UNIT_FIELD: string = 'unit';
export const BOXES_FIELD: string = 'boxes';
export const RESPONSIBLE_FIELD: string = 'responsible';
export const IN_CHARGE_FIELD: string = 'inCharge';
export const PHONE_FIELD: string = 'phone';
export const ORDER_FIELD: string = 'order';
export const START_DATE_FIELD: string = 'startDate';
export const END_DATE_FIELD: string = 'endDate';

// RECIPIENTS_STEP
export const RECIPIENTS_FIELD: string = 'recipients';
export const NAME_FIELD: string = 'name';
export const EMAIL_FIELD: string = 'email';

// DOCS_TO_TRANSFER_STEP
export const DOCS_TO_TRANSFER_FIELD: string = 'documents';

// FILES_STEP
export const FILES_FIELD: string = 'files';